export { DEFAULT_STATE_COPY } from '../../../constants';
export const CONNECTION_ERROR_CODES = ['NETWORK_ERROR', 'NO_CONNECTION'];
